import { render, staticRenderFns } from "./RecCompanyList.vue?vue&type=template&id=55606389&scoped=true"
import script from "./RecCompanyList.vue?vue&type=script&lang=js"
export * from "./RecCompanyList.vue?vue&type=script&lang=js"
import style0 from "./RecCompanyList.vue?vue&type=style&index=0&id=55606389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55606389",
  null
  
)

export default component.exports